import { type StepEntry } from 'customer-flows/components/_config/registry'
import defaults from './defaults'
import variants from './variants'

export const steps = [
  ...defaults,
  ...variants
] satisfies StepEntry[]
